import { FC } from "react";
import { HighlightWordProps } from "./types";

export const WordByWordCaption: FC<HighlightWordProps> = ({
  text,
  isHighlighted,
  currentTime = 0,
  wordStart = 0,
}) => (
  <span
    style={{
      display: "inline-block",
      padding: "0 5px",
      opacity: !isHighlighted ? 0.7 : 1,
      transition: "opacity 0.2s ease",
      visibility: currentTime >= wordStart ? "visible" : "hidden",
    }}
  >
    {text}
  </span>
);
